import { sendClickHouseAnalytic } from '@shared/api/analytics/template'
import { PickAnalytic } from '@shared/api/analytics/types/types'

export const EGGQuickSearch = {
  page_shown: () =>
    sendClickHouseAnalytic({
      section_name: 'search',
      event_name: 'block_appear',
    }),
  text_type: () => sendClickHouseAnalytic({ section_name: 'search', event_name: 'type_text' }),
  suggest_click: (props: PickAnalytic<'object_type' | 'object_id' | 'section_index'>) =>
    sendClickHouseAnalytic({
      ...props,
      section_name: 'search',
      event_name: 'element_click',
      element_type: 'suggest',
    }),
  reserve_click: (props: PickAnalytic<'object_type' | 'object_id' | 'section_index' | 'rating' | 'afisha_selected'>) =>
    sendClickHouseAnalytic({
      ...props,
      section_name: 'search',
      event_name: 'element_click',
      element_type: 'reserve',
    }),
  all_results_click: () =>
    sendClickHouseAnalytic({
      section_name: 'search',
      event_name: 'element_click',
      element_type: 'all_result',
    }),
  close_click: () =>
    sendClickHouseAnalytic({ section_name: 'search', event_name: 'element_click', element_type: 'close' }),
}
